module.exports = __webpack_public_path__ + "static/media/help.6e3c86ed.svg";